import { render, staticRenderFns } from "./WhatsappMessage.vue?vue&type=template&id=5ebc3acc&"
import script from "./WhatsappMessage.vue?vue&type=script&lang=js&"
export * from "./WhatsappMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports